import { useTranslation } from "react-i18next";
import useSEO from "@/hooks/useSEO";
import { LocalBusinessSchema } from "@/components/SEOStructuredData";
import Header from "@/components/Header";
import SkipToContent from "@/components/SkipToContent";
import HeroSection from "@/components/HeroSection";
import ClientLogos from "@/components/ClientLogos";
import TrustHighlights from "@/components/TrustHighlights";
import FeaturedTalent from "@/components/FeaturedTalent";
import ServicesSection from "@/components/ServicesSection";
import HowItWorks from "@/components/HowItWorks";
import Testimonial from "@/components/Testimonial";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

const Index = () => {
  const { t } = useTranslation();

  useSEO({
    title: undefined, // Use default site title for homepage
    description: t("seo.homeDescription", "Professional voiceover and acting talent across Canada. First Stage Talent connects you with skilled performers for commercials, narration, e-learning, and media production."),
  });

  return (
    <div className="min-h-screen">
      <LocalBusinessSchema />
      <SkipToContent />
      <Header />
      <main id="main-content" tabIndex={-1} className="outline-none">
        <HeroSection />
        <ClientLogos />
        <TrustHighlights />
        <FeaturedTalent />
        <ServicesSection />
        <HowItWorks />
        <Testimonial />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
